import { Grid } from "@mui/material";
import dayjs from "dayjs";
import CustomDatePicker from "../../../../CustomDatePicker";
import Input from "../../../../Input";

export const PaymentCashFields = ({ formik }: { formik: any }) => {
  return (
    <Grid container width={"100%"}>
      <Grid item xs={6}>
        <CustomDatePicker
          required
          minDate={dayjs(new Date())}
          label="Date"
          name="paymentDate"
          value={formik.values?.paymentDate}
          onChange={(val) => formik.setFieldValue("paymentDate", val)}
          handleBlur={formik.handleBlur}
          error={formik.touched?.paymentDate && formik.errors?.paymentDate}
        />
      </Grid>
      <Grid item xs={12} mt={2}>
        <Input
          label="Note"
          textFieldProps={{
            placeholder: "Enter Note",
            rows: 3,
            multiline: true,
            name: "note",
            onChange: formik.handleChange,
            value: formik.values.note,
          }}
        />
      </Grid>
    </Grid>
  );
};
